import React, { useState, useRef, useEffect } from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/home/Footer';
import { FaSearch, FaTimes, FaArrowLeft, FaVolumeUp, FaVolumeMute, FaPlay } from 'react-icons/fa';

// Gallery categories - now including specific tours
const categories = [
  'All Tours',
  'Big Five Safari',
  'Namibia Highlights',
  'Walvisbay Excursion',
  'Namwild Safari',
  'Victoria Falls'
];

// Define TypeScript interface for gallery media items
interface GalleryMedia {
  id: number;
  src: string;
  alt: string;
  category: string;
  location: string;
  type: 'image' | 'video';
  videoUrl?: string;
}

// Gallery media data organized by tours
const galleryMedia: GalleryMedia[] = [
  // Big Five Safari Tour
  {
    id: 1,
    src: '/Tours/bigfivehero.jpeg',
    alt: 'Lion in Etosha',
    category: 'Big Five Safari',
    location: 'Etosha National Park',
    type: 'image'
  },
  {
    id: 2,
    src: '/Tours/Lion.jpeg',
    alt: 'Lion Pride',
    category: 'Big Five Safari',
    location: 'Etosha National Park',
    type: 'image'
  },
  {
    id: 3,
    src: '/Tours/etosha.jpg',
    alt: 'Etosha Wildlife',
    category: 'Big Five Safari',
    location: 'Etosha National Park',
    type: 'image'
  },
  {
    id: 4,
    src: '/Tours/Buffaloe.jpg',
    alt: 'Cape Buffalo Herd',
    category: 'Big Five Safari',
    location: 'Etosha National Park',
    type: 'image'
  },
  {
    id: 5,
    src: '/Tours/Leopard.jpg',
    alt: 'Leopard',
    category: 'Big Five Safari',
    location: 'Etosha National Park',
    type: 'image'
  },
  {
    id: 6,
    src: '/Tours/girrafes.jpg',
    alt: 'Giraffes at Etosha National Park',
    category: 'Big Five Safari',
    location: 'Etosha National Park',
    type: 'video',
    videoUrl: 'https://res.cloudinary.com/dik2mqn3b/video/upload/q_auto:best,f_auto/WhatsApp_Video_2025-02-26_at_10.47.48_kufqzg.mp4'
  },
  {
    id: 7,
    src: '/Tours/safaridrive.jpg',
    alt: 'Safari Vehicle Tour',
    category: 'Big Five Safari',
    location: 'Etosha National Park',
    type: 'video',
    videoUrl: 'https://res.cloudinary.com/dik2mqn3b/video/upload/q_auto:best,f_auto/WhatsApp_Video_2025-02-26_at_10.47.48_kufqzg.mp4'
  },
  {
    id: 8,
    src: '/Tours/Cheetah.jpg',
    alt: 'Cheetah',
    category: 'Big Five Safari',
    location: 'Etosha National Park',
    type: 'video',
    videoUrl: 'https://res.cloudinary.com/dik2mqn3b/video/upload/q_auto:best,f_auto/WhatsApp_Video_2025-02-26_at_10.47.48_kufqzg.mp4'
  },

  // Namibia Highlights Tour
  {
    id: 9,
    src: '/Tours/Namibia Highlights.jpg',
    alt: 'Sossusvlei Sand Dunes',
    category: 'Namibia Highlights',
    location: 'Sossusvlei',
    type: 'image'
  },
  {
    id: 10,
    src: '/Tours/vlei.jpg',
    alt: 'Deadvlei White Clay Pan',
    category: 'Namibia Highlights',
    location: 'Sossusvlei',
    type: 'image'
  },
  {
    id: 11,
    src: '/Tours/moondscape.jpg',
    alt: 'Moondscape Landscape',
    category: 'Namibia Highlights',
    location: 'Damaraland',
    type: 'image'
  },
  {
    id: 12,
    src: '/Tours/Highlighttour.jpg',
    alt: 'Namibia Landscape',
    category: 'Namibia Highlights',
    location: 'Southern Namibia',
    type: 'image'
  },
  {
    id: 13,
    src: '/Tours/Dune7.jpg',
    alt: 'Dune 7',
    category: 'Namibia Highlights',
    location: 'Sossusvlei',
    type: 'video',
    videoUrl: 'https://res.cloudinary.com/dik2mqn3b/video/upload/q_auto:best,f_auto/WhatsApp_Video_2025-02-26_at_10.47.48_kufqzg.mp4'
  },
  {
    id: 14,
    src: '/Tours/sos.jpeg',
    alt: 'Sossusvlei',
    category: 'Namibia Highlights',
    location: 'Namib-Naukluft Park',
    type: 'video',
    videoUrl: 'https://res.cloudinary.com/dik2mqn3b/video/upload/q_auto:best,f_auto/WhatsApp_Video_2025-02-26_at_10.47.48_kufqzg.mp4'
  },
  {
    id: 15,
    src: '/Tours/welwit.jpg',
    alt: 'Welwitschia Plants',
    category: 'Namibia Highlights',
    location: 'Namib Desert',
    type: 'video',
    videoUrl: 'https://res.cloudinary.com/dik2mqn3b/video/upload/q_auto:best,f_auto/WhatsApp_Video_2025-02-26_at_10.47.48_kufqzg.mp4'
  },
  {
    id: 16,
    src: '/Tours/Paradise.jpg',
    alt: 'Desert Landscape',
    category: 'Namibia Highlights',
    location: 'Namib Desert',
    type: 'image'
  },

  // Walvisbay Excursion
  {
    id: 17,
    src: '/Tours/WalvisExcurrions.jpg',
    alt: 'Walvis Bay Excursion',
    category: 'Walvisbay Excursion',
    location: 'Walvis Bay',
    type: 'image'
  },
  {
    id: 18,
    src: '/Tours/walvis.jpeg',
    alt: 'Walvis Bay',
    category: 'Walvisbay Excursion',
    location: 'Walvis Bay',
    type: 'image'
  },
  {
    id: 19,
    src: '/Tours/Lagoon.jpg',
    alt: 'Flamingos at Lagoon',
    category: 'Walvisbay Excursion',
    location: 'Walvis Bay Lagoon',
    type: 'image'
  },
  {
    id: 20,
    src: '/Tours/Dune7.jpg',
    alt: 'Dune 7',
    category: 'Walvisbay Excursion',
    location: 'Swakopmund',
    type: 'image'
  },
  {
    id: 21,
    src: '/Tours/Paradise.jpg',
    alt: 'Coastal Paradise',
    category: 'Walvisbay Excursion',
    location: 'Walvis Bay',
    type: 'video',
    videoUrl: 'https://res.cloudinary.com/dik2mqn3b/video/upload/q_auto:best,f_auto/WhatsApp_Video_2025-02-26_at_10.47.48_kufqzg.mp4'
  },
  {
    id: 22,
    src: '/Tours/moondscape.jpg',
    alt: 'Moondscape Landscape',
    category: 'Walvisbay Excursion',
    location: 'Atlantic Coast',
    type: 'video',
    videoUrl: 'https://res.cloudinary.com/dik2mqn3b/video/upload/q_auto:best,f_auto/WhatsApp_Video_2025-02-26_at_10.47.48_kufqzg.mp4'
  },
  {
    id: 23,
    src: '/Tours/safaridrive.jpg',
    alt: 'Coastal Safari Drive',
    category: 'Walvisbay Excursion',
    location: 'Cape Cross',
    type: 'video',
    videoUrl: 'https://res.cloudinary.com/dik2mqn3b/video/upload/q_auto:best,f_auto/WhatsApp_Video_2025-02-26_at_10.47.48_kufqzg.mp4'
  },
  {
    id: 24,
    src: '/Tours/welwit.jpg',
    alt: 'Welwitschia Plants',
    category: 'Walvisbay Excursion',
    location: 'Skeleton Coast',
    type: 'video',
    videoUrl: 'https://res.cloudinary.com/dik2mqn3b/video/upload/q_auto:best,f_auto/WhatsApp_Video_2025-02-26_at_10.47.48_kufqzg.mp4'
  }
];

// Separate media into categories for sectioned display
const getMediaByCategory = (category: string): GalleryMedia[] => {
  return galleryMedia.filter(item =>
    category === 'All Tours' ? true : item.category === category
  );
};

const Gallery: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState('All Tours');
  const [selectedMedia, setSelectedMedia] = useState<typeof galleryMedia[0] | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isMuted, setIsMuted] = useState(true);
  const [hoveredVideoId, setHoveredVideoId] = useState<number | null>(null);
  const [inViewVideos, setInViewVideos] = useState<Set<number>>(new Set());
  const videoRefs = useRef<{ [key: number]: HTMLVideoElement | null }>({});
  const modalVideoRef = useRef<HTMLVideoElement | null>(null);
  const modalOverlayRef = useRef<HTMLDivElement | null>(null);
  const videoContainers = useRef<{ [key: number]: HTMLDivElement | null }>({});

  // Filter media based on category and search query
  const filteredMedia = galleryMedia.filter(media => {
    const matchesCategory = selectedCategory === 'All Tours' || media.category === selectedCategory;
    const matchesSearch = searchQuery === '' ||
      media.alt.toLowerCase().includes(searchQuery.toLowerCase()) ||
      media.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
      media.category.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Auto-play the video in the modal when it's mounted
  useEffect(() => {
    if (selectedMedia?.type === 'video' && modalVideoRef.current) {
      modalVideoRef.current.muted = isMuted;
      modalVideoRef.current.play().catch(err => {
        console.error("Error playing modal video on mount:", err);
      });
    }
  }, [selectedMedia, modalVideoRef.current]);

  // Handle closing modal with escape key
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && selectedMedia) {
        setSelectedMedia(null);
      }
    };

    window.addEventListener('keydown', handleEscKey);
    return () => window.removeEventListener('keydown', handleEscKey);
  }, [selectedMedia]);

  // Handle clicking outside to close modal
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (modalOverlayRef.current && event.target === modalOverlayRef.current) {
        setSelectedMedia(null);
      }
    };

    if (selectedMedia) {
      document.addEventListener('click', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [selectedMedia]);

  // Toggle sound for video in modal
  const toggleSound = () => {
    setIsMuted(!isMuted);
    if (modalVideoRef.current && selectedMedia) {
      // Simply set the muted property of the video element
      modalVideoRef.current.muted = !isMuted;
    }
  };

  // Setup IntersectionObserver for videos to play only when in viewport
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5, // 50% of the item must be visible
    };

    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        const id = parseInt(entry.target.getAttribute('data-video-id') || '0', 10);
        if (!id) return;

        if (entry.isIntersecting) {
          setInViewVideos(prev => new Set(prev).add(id));
          console.log(`Video ${id} is now in view`);
        } else {
          setInViewVideos(prev => {
            const updated = new Set(prev);
            updated.delete(id);
            return updated;
          });
          console.log(`Video ${id} is now out of view`);
          if (videoRefs.current[id]) {
            videoRefs.current[id]?.pause();
          }
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    // Initialize video containers refs
    const videoItems = galleryMedia.filter(item => item.type === 'video');
    videoItems.forEach(item => {
      if (videoContainers.current[item.id] && !videoContainers.current[item.id]?.hasAttribute('data-video-id')) {
        videoContainers.current[item.id]?.setAttribute('data-video-id', item.id.toString());
        observer.observe(videoContainers.current[item.id] as Element);
      }
    });

    return () => {
      // Cleanup
      observer.disconnect();
    };
  }, []);

  // Handle mouse enter for video elements - start playing if in view
  const handleVideoMouseEnter = (media: GalleryMedia): void => {
    setHoveredVideoId(media.id);
    if (videoRefs.current[media.id] && inViewVideos.has(media.id)) {
      // Only play if video is in viewport
      const videoElement = videoRefs.current[media.id];
      console.log("Starting video playback on hover:", media.id);
      if (videoElement) {
        // Reset the video to the beginning if it was previously played
        videoElement.currentTime = 0;
        // Play the video
        videoElement.play().catch(err => {
          console.error("Error playing video:", err);
        });
      }
    }
  };

  // Handle mouse leave for video elements - stop playing
  const handleVideoMouseLeave = (media: GalleryMedia): void => {
    setHoveredVideoId(null);
    if (videoRefs.current[media.id]) {
      // Using the HTML5 video API to pause
      const videoElement = videoRefs.current[media.id];
      console.log("Stopping video playback on leave:", media.id);
      if (videoElement) {
        videoElement.pause();
      }
    }
  };

  // Handle opening the modal without interrupting video playback
  const handleMediaClick = (media: GalleryMedia): void => {
    setSelectedMedia(media);
    setIsMuted(true); // Always start with sound off

    // Set timeout to allow the modal to render before accessing the ref
    setTimeout(() => {
      if (media.type === 'video' && modalVideoRef.current) {
        // Start playing the video
        console.log("Playing video in modal");
        modalVideoRef.current.muted = true; // Ensure it's muted initially
        modalVideoRef.current.play().catch(err => {
          console.error("Error playing modal video:", err);
        });
      }
    }, 100);
  };

  // Handle modal overlay click to close
  const handleModalClick = (e: React.MouseEvent): void => {
    // Close the modal if clicking on the overlay (not the content)
    if (e.target === modalOverlayRef.current) {
      setSelectedMedia(null);
    }
  };

  // Organize media into sections
  const renderMediaSections = () => {
    // Initialize mediaByCategory with proper typing
    const mediaByCategory: Record<string, typeof galleryMedia> = {};

    // Populate mediaByCategory
    categories.forEach(category => {
      if (category !== 'All Tours') {
        mediaByCategory[category] = getMediaByCategory(category).filter(media =>
          searchQuery === '' ||
          media.alt.toLowerCase().includes(searchQuery.toLowerCase()) ||
          media.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
          media.category.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }
    });

    if (selectedCategory !== 'All Tours') {
      // When a specific category is selected, show all media for that category
      const filteredMedia = getMediaByCategory(selectedCategory).filter(media =>
        searchQuery === '' ||
        media.alt.toLowerCase().includes(searchQuery.toLowerCase()) ||
        media.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
        media.category.toLowerCase().includes(searchQuery.toLowerCase())
      );

      if (filteredMedia.length === 0) {
        return (
          <div className="text-center py-16 animate-fade-up">
            <h2 className="text-2xl text-gray-600 mb-4">No results found</h2>
            <p className="text-gray-500">Try adjusting your search or filter criteria</p>
            <button
              onClick={() => { setSearchQuery(''); setSelectedCategory('All Tours'); }}
              className="mt-6 px-6 py-2 bg-amber-700 text-white rounded-lg hover:bg-amber-800 transition-colors"
            >
              Reset Filters
            </button>
          </div>
        );
      }

      return (
        <div className="mb-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {filteredMedia.map(renderMediaItem)}
          </div>
        </div>
      );
    }

    // When 'All Tours' is selected, show sections by tour
    return Object.entries(mediaByCategory).map(([category, items], categoryIndex) => {
      if (items.length === 0) return null;

      const imageItems = items.filter(item => item.type === 'image');
      const videoItems = items.filter(item => item.type === 'video');

      return (
        <div key={category} className="mb-20 pb-16 border-b border-gray-200 animate-fade-up" style={{ animationDelay: `${categoryIndex * 100}ms` }}>
          <h2 className="text-3xl font-bold mb-8 text-[#C05B2A] animate-fade-up">
            {category}
          </h2>

          {imageItems.length > 0 && (
            <div className="mb-12 animate-fade-up animation-delay-200">
              <h3 className="text-xl font-semibold mb-4 text-gray-700">Images</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {imageItems
                  .filter(item => searchQuery === '' ||
                    item.alt.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    item.location.toLowerCase().includes(searchQuery.toLowerCase()))
                  .slice(0, 4)
                  .map(renderMediaItem)}
              </div>
            </div>
          )}

          {videoItems.length > 0 && (
            <div className="mb-12 animate-fade-up animation-delay-400">
              <h3 className="text-xl font-semibold mb-4 text-gray-700">Videos</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {videoItems
                  .filter(item => searchQuery === '' ||
                    item.alt.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    item.location.toLowerCase().includes(searchQuery.toLowerCase()))
                  .slice(0, 4)
                  .map(renderMediaItem)}
              </div>
            </div>
          )}
        </div>
      );
    });
  };

  // Render individual media items
  const renderMediaItem = (media: GalleryMedia) => (
    <div
      key={media.id}
      onClick={() => handleMediaClick(media)}
      className="group relative rounded-xl overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-all transform hover:-translate-y-1 h-64 animate-fade-up animation-delay-300"
      onMouseEnter={() => media.type === 'video' && handleVideoMouseEnter(media)}
      onMouseLeave={() => media.type === 'video' && handleVideoMouseLeave(media)}
      ref={el => videoContainers.current[media.id] = el}
    >
      {media.type === 'image' ? (
        <img
          src={media.src}
          alt={media.alt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
      ) : (
        <div className="relative w-full h-full">
          {/* Video thumbnail with play button overlay */}
          <img
            src={media.src}
            alt={media.alt}
            className="w-full h-full object-cover absolute inset-0 z-10"
            style={{ opacity: hoveredVideoId === media.id ? 0 : 1 }}
            loading="lazy"
          />
          {/* Play button overlay */}
          <div
            className="absolute inset-0 z-20 flex items-center justify-center bg-black/30 transition-opacity"
            style={{ opacity: hoveredVideoId === media.id ? 0 : 1 }}
          >
            <div className="bg-white/80 rounded-full p-3">
              <FaPlay className="text-amber-700" />
            </div>
          </div>
          {/* Actual video element - following guidelines implementation */}
          <video
            ref={el => videoRefs.current[media.id] = el}
            src={media.videoUrl}
            className="w-full h-full object-cover absolute inset-0"
            autoPlay={inViewVideos.has(media.id) && hoveredVideoId === media.id}
            muted
            loop
            playsInline
            preload="auto"
          />
          {/* Semi-transparent gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-white opacity-20 pointer-events-none"></div>
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-0 group-hover:opacity-90 transition-opacity flex items-end">
        <div className="p-4 text-white w-full">
          <h3 className="font-medium text-lg">{media.alt}</h3>
          <p className="text-sm opacity-90">{media.location}</p>
        </div>
      </div>
    </div>
  );

  // Pre-cache videos when the page loads for faster playback
  useEffect(() => {
    // Preload the videos as recommended in the guidelines
    const preloadVideos = async () => {
      console.log("Preloading videos for faster playback");

      // Get all video media items
      const videoItems = galleryMedia.filter(media => media.type === 'video');

      // Limit to first few videos to avoid excessive loading
      const maxVideosToPreload = 3;

      videoItems.slice(0, maxVideosToPreload).forEach(media => {
        if (media.videoUrl) {
          const videoPreload = document.createElement('link');
          videoPreload.rel = 'preload';
          videoPreload.href = media.videoUrl;
          videoPreload.as = 'video';
          document.head.appendChild(videoPreload);

          console.log(`Preloaded video: ${media.alt}`);
        }
      });
    };

    // Call the preload function immediately for priority videos
    preloadVideos();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navbar - absolutely positioned at top */}
      <header className="absolute top-0 left-0 right-0 z-50">
        <Navbar />
      </header>

      {/* Improved Hero Section */}
      <div className="relative h-[60vh] min-h-[500px] flex items-center justify-center bg-gray-900 border-b border-gray-800 overflow-hidden">
        <img
          src="/gallery images/gallerypropic.jpeg"
          alt="Rion Wildlife Safaris Gallery"
          className="absolute inset-0 w-full h-full object-cover"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/40 to-black/80 pointer-events-none"></div>

        <div className="relative z-10 text-center text-white px-4 max-w-4xl">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-fade-up">Safari Gallery</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto animate-fade-up animation-delay-200">Experience the captivating beauty and wildlife of Southern Africa through our curated collection of breathtaking moments</p>
        </div>
        <div className="absolute bottom-0 w-full h-16 bg-gradient-to-t from-gray-50 to-transparent"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {/* Search and Filter */}
        <div className="mb-16 flex flex-col md:flex-row gap-6 items-center justify-between bg-white rounded-lg p-6 shadow-md animate-fade-up animation-delay-300">
          <div className="flex flex-wrap gap-3">
            {categories.map((category, index) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-5 py-3 rounded-full text-sm font-medium transition-all animate-fade-up animation-delay-${300 + (index * 100)} ${selectedCategory === category
                  ? 'bg-[#C05B2A] text-white shadow-md transform scale-105'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:shadow'
                  }`}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="relative w-full md:w-72 animate-fade-up animation-delay-400">
            <input
              type="text"
              placeholder="Search gallery..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md focus:ring-[#C05B2A] focus:border-[#C05B2A] shadow-sm"
            />
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          </div>
        </div>

        {/* Gallery Sections */}
        {renderMediaSections()}

        {/* No Results Message */}
        {filteredMedia.length === 0 && (
          <div className="text-center py-20 bg-white rounded-lg shadow-sm">
            <p className="text-gray-500 text-lg mb-3">No media found matching your criteria.</p>
            <button
              onClick={() => {
                setSelectedCategory('All Tours');
                setSearchQuery('');
              }}
              className="px-6 py-3 bg-[#C05B2A] text-white rounded-full hover:bg-[#A64D23] transition-colors"
            >
              Clear filters
            </button>
          </div>
        )}
      </div>

      {/* Modal for viewing media */}
      {selectedMedia && (
        <div
          ref={modalOverlayRef}
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 animate-fade-in"
          onClick={handleModalClick}
        >
          <div className="relative max-w-5xl w-full rounded-lg overflow-hidden">
            {/* Back Button */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedMedia(null);
              }}
              className="absolute top-4 left-4 z-10 bg-black bg-opacity-50 hover:bg-opacity-70 text-white p-3 rounded-full transition-all"
              aria-label="Return to gallery"
            >
              <FaArrowLeft />
            </button>

            {/* Close Button */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedMedia(null);
              }}
              className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 hover:bg-opacity-70 text-white p-3 rounded-full transition-all"
              aria-label="Close"
            >
              <FaTimes />
            </button>

            {/* Sound Toggle Button for Videos */}
            {selectedMedia.type === 'video' && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleSound();
                }}
                className="absolute top-4 right-20 z-10 bg-black bg-opacity-50 hover:bg-opacity-70 text-white p-3 rounded-full transition-all"
                aria-label={isMuted ? "Unmute" : "Mute"}
              >
                {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
              </button>
            )}

            <div className="bg-black rounded-t-lg">
              {selectedMedia.type === 'video' ? (
                <div className="aspect-video w-full">
                  <video
                    ref={modalVideoRef}
                    src={selectedMedia.videoUrl}
                    className="w-full h-full"
                    muted={isMuted}
                    loop
                    playsInline
                    autoPlay
                    controls
                    preload="auto"
                    style={{
                      objectFit: 'cover',
                      width: '100%',
                      height: '100%',
                      background: '#000'
                    }}
                  ></video>
                </div>
              ) : (
                <img
                  src={selectedMedia.src}
                  alt={selectedMedia.alt}
                  className="w-full h-auto rounded-t-lg"
                />
              )}
            </div>

            <div className="bg-white p-6 rounded-b-lg">
              <h3 className="text-2xl font-bold text-gray-900">{selectedMedia.alt}</h3>
              <p className="text-lg text-gray-700 mt-2">{selectedMedia.location}</p>
              <p className="text-sm text-gray-500 mt-4">
                Tour: {selectedMedia.category}
              </p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Gallery; 